import React from 'react';
import { ArrowRight, Copy, Check } from 'lucide-react';
import { BRAND, STATS } from '../mock';

export default function Hero() {
  const [copied, setCopied] = React.useState(false);

  const copyCode = () => {
    navigator.clipboard.writeText(BRAND.couponCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-24 bg-[#f7f2ec] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 mb-8">
            <span className="h-px w-8 bg-stone-400" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-stone-600">Yeni Sezon · 2026</span>
          </div>

          <h1 className="font-serif text-[52px] sm:text-[68px] lg:text-[88px] leading-[0.95] text-stone-900 tracking-tight">
            Zarafetin
            <br />
            yeni <em className="italic font-light text-stone-700">adresi</em>.
          </h1>

          <p className="mt-8 max-w-lg text-[15px] leading-relaxed text-stone-600">
            Tesettürün inceliğini modern bir duruşla buluşturuyoruz. Özenle seçilmiş kumaşlar,
            sade çizgiler ve her detayında zarafet barındıran koleksiyonumuzla tanışın.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#koleksiyon"
              className="group inline-flex items-center gap-3 px-7 py-4 bg-stone-900 text-[#f7f2ec] text-[12px] tracking-[0.22em] uppercase hover:bg-stone-800 transition-colors"
            >
              Koleksiyonu Keşfet
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          {/* Coupon */}
          <div className="mt-12 max-w-md bg-white/60 backdrop-blur-sm border border-stone-200 p-6">
            <div className="flex items-start gap-4">
              <div className="h-10 w-10 flex items-center justify-center bg-stone-900 text-[#f7f2ec] rounded-full text-lg">
                ✦
              </div>
              <div className="flex-1">
                <p className="text-[10px] tracking-[0.28em] uppercase text-stone-500">Özel Kupon Kodu</p>
                <button
                  onClick={copyCode}
                  className="mt-1 flex items-center gap-2 font-mono text-xl text-stone-900 hover:text-stone-700 transition-colors"
                >
                  {BRAND.couponCode}
                  {copied ? <Check className="h-4 w-4 text-green-700" /> : <Copy className="h-4 w-4" />}
                </button>
                <p className="mt-2 text-[13px] text-stone-600">
                  Sepette {BRAND.couponMinItems} ürün veya üzeri alışverişte{' '}
                  <span className="font-semibold text-stone-900">{BRAND.couponDiscount}₺ indirim</span>!
                  Kodu WhatsApp siparişinde belirtin.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-4 bg-stone-200/40 -rotate-2" />
            <img
              src="/products/zumra_5869_8474.jpg"
              alt="Leila Tesettür Koleksiyon"
              className="relative w-full aspect-[4/5] object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-[#f7f2ec] border border-stone-200 px-6 py-4 max-w-[240px]">
              <p className="font-serif italic text-stone-800 leading-snug">
                "Sadelik, en zarif süstür."
              </p>
              <p className="mt-2 text-[10px] tracking-[0.24em] uppercase text-stone-500">— Leila Felsefesi</p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-24 grid grid-cols-3 gap-6 border-t border-stone-200 pt-10">
        {STATS.map((s) => (
          <div key={s.label} className="text-center sm:text-left">
            <div className="font-serif text-4xl lg:text-5xl text-stone-900">{s.value}</div>
            <div className="mt-1 text-[11px] tracking-[0.22em] uppercase text-stone-500">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
